module.exports = __webpack_public_path__ + "static/media/workshop_data_pc.04850742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/desenvolvendoApis/workshop_data_pc.png
// module id = 26
// module chunks = 0